import { useEffect } from "react";
import { Dna } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import "../css/main.css";
import { getOrders } from "../redux/action";

function Orders() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { data, loading, error } = useSelector((state) => state.Orders);
  const get = data ? data : false;
  let OrderNumber = 0;
  useEffect(() => {
    dispatch(getOrders());
  }, []);
  return (
    <div className="pt-20 pb-24 text-slate-100">
      {loading ? (
        <div className="mt-32 flex justify-center">
          <Dna
            visible={true}
            height="150"
            width="150"
            ariaLabel="dna-loading"
            wrapperStyle={{}}
            wrapperClass="dna-wrapper"
          />
        </div>
      ) : error ? (
        <div className="flex justify-center">
          <div className="alert alert-error shadow-lg w-8/12 mt-20">
            <div>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="stroke-current flex-shrink-0 h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              <span>Error! Task failed successfully.</span>
            </div>
          </div>
        </div>
      ) : get?.length ? (
        get.map((item, index) => {
          return (
            <div className="item" key={index}>
              <div className="flex justify-center">
                <div className="w-11/12">
                  <div
                    className="w-full bg-gradient-to-r from-violet-900 to-indigo-900 my-2 p-5 rounded-xl block lg:flex lg:justify-evenly lg:items-center hover:cursor-pointer hover:brightness-75 hover:scale-105 transition duration-700"
                    onClick={() => {
                      navigate("/OrderId", {
                        state: item._id,
                      });
                    }}
                  >
                    <div className="text-base sm:text-xl lg:text-base xl:text-xl my-5 flex justify-start items-center">
                      <span className="font-semibold text-teal-500 mr-2">
                        Order Number :
                      </span>
                      {(OrderNumber += index + 1)}
                    </div>
                    <div className="text-base sm:text-xl lg:text-base xl:text-xl my-5 flex justify-start items-center">
                      <span className="font-semibold text-teal-500 mr-2">
                        Number Of Products :
                      </span>
                      {item.orderItems.length}
                    </div>
                    <div className="text-base sm:text-xl lg:text-base xl:text-xl my-5 flex justify-start items-center">
                      <span className="font-semibold text-teal-500 mr-2">
                        total Price :
                      </span>
                      {item.totalPrice} $
                    </div>
                    <div className="text-base sm:text-xl lg:text-base xl:text-xl my-5 flex justify-start items-center">
                      <span className="font-semibold text-teal-500 mr-2">
                        Shipping Price :
                      </span>
                      {item.shippingPrice} $
                    </div>
                    <div className="text-base sm:text-xl lg:text-base xl:text-xl my-5 flex justify-start items-center">
                      <span className="font-semibold text-teal-500 mr-2">
                        Payment Method :
                      </span>
                      {item.paymentMethod}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })
      ) : (
        <div className="mt-60 text-xl md:text-4xl text-red-800 font-semibold">
          Your orders are empty
        </div>
      )}
    </div>
  );
}

export default Orders;
